import { BodyText } from '@/components/BodyText';
import { Box } from '@mui/material';

export const AssemblyGuidelinesView = () => {
  return (
    <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', textAlign: 'left', color: 'text.secondary' }}>
      <Box sx={{ flex: 1 }}>
        <BodyText component='p'>
          Uploading assembly file dependencies separately allows you to match, compare, and get duplication and
          simplification reports at the part level. Uploading a single-body assembly limits these capabilities to the
          entire assembly.
        </BodyText>
        <BodyText component='p' sx={{ marginTop: '12px' }}>
          Upload assembly files with the same folder structure and filenames as your source design (including case).
          Physna resolves dependencies and flags missing references. You can resolve missing dependencies by uploading
          the missing files.
        </BodyText>
      </Box>
    </Box>
  );
};
